export function localizedName(
  entity: { name: string; nameEn?: string | null },
  language: string
): string {
  if (language === 'he') return entity.name;
  return entity.nameEn || entity.name;
}
